export default function About() {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="relative bg-espresso text-cream py-24 md:py-40 overflow-hidden z-10"
    >
      <div className="absolute inset-0 bg-[radial-gradient(50%_40%_at_80%_20%,rgba(196,137,61,0.14),transparent_60%)]" />
      <div className="grain absolute inset-0 opacity-70" />

      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10 grid md:grid-cols-12 gap-10 md:gap-14 items-start">
        <div className="md:col-span-5 md:sticky md:top-28 reveal-left">
          <div className="eyebrow text-gold mb-6 reveal-eyebrow">Nossa história</div>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-[-0.02em] reveal-clip">
            Uma boutique de café <em className="italic text-gold">no coração de Alfenas.</em>
          </h2>

          <div className="mt-10 relative rounded-[14px] overflow-hidden border border-cream/10 reveal-scale">
            <img
              src="/historia-v2.avif"
              alt="Interior do Empório do Café em Alfenas"
              className="w-full h-[380px] object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-espresso to-transparent p-6">
              <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-cream/60">
                Praça Getúlio Vargas, 367 · Alfenas / MG
              </div>
            </div>
          </div>
        </div>

        <div className="md:col-span-6 md:col-start-7 space-y-7 text-cream/80 text-[17px] md:text-lg leading-[1.8] reveal-right">
          <p>
            <span className="float-left font-display text-gold text-[96px] leading-[0.75] mr-4 mt-2 italic">
              O
            </span>
            Empório do Café nasceu de uma paixão simples e profunda: acreditar
            que um bom café é capaz de transformar um momento comum em memória
            afetiva.
          </p>
          <p>
            Somos uma boutique especializada em cafés de alta qualidade,
            instalada no coração de Alfenas — cidade que carrega no sangue a
            tradição cafeeira do sul de Minas Gerais. Aqui, cada grão é
            escolhido a dedo. Cada queijo vem de um produtor que a gente conhece
            pelo nome. Cada cachaça tem uma história de dedicação por trás do
            rótulo.
          </p>
          <p>
            Mais do que uma loja, somos um espaço de encontros, conversas e
            descobertas. Você pode chegar para tomar um café gelado, sair com
            uma aula sobre métodos de extração, e ainda levar na bolsa um kit
            completo de sabores mineiros. Isso acontece todo dia aqui.
          </p>
          <p className="font-display italic text-gold text-2xl md:text-3xl leading-snug pt-2">
            Seja bem-vindo ao Empório. O café está pronto.
          </p>

          <div className="pt-8 mt-8 border-t border-cream/10 grid grid-cols-3 gap-6">
            {[
              ["1°", "aguardente de café do Brasil"],
              ["50+", "tipos de café especial"],
              ["3", "terroirs da Canastra"],
            ].map(([n, label], i) => (
              <div key={i}>
                <div className="font-display text-4xl md:text-5xl text-cream leading-none">
                  {n}
                </div>
                <div className="font-mono text-[10px] tracking-[0.28em] uppercase mt-3 text-cream/55">
                  {label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
